import { useEffect } from 'react'
import { ContactJson } from 'app/types/entities'
import { ConversationPanel } from './ConversationPanel'
import { useContactMessages } from './useContactMessages'

// Keep the unread badge visible long enough that opening a row does not clear it under the click.
const MARK_READ_DELAY_MS = 800

/**
 * Mount only while a row is open: `useContactMessages` fetches on mount, so
 * rendering this per row would fire a thread query per person listed.
 */
export function ThreadExpansion({
  contact,
  onClose,
  onRead,
}: {
  contact: ContactJson
  onClose: () => void
  onRead: () => void
}) {
  const thread = useContactMessages(contact)
  const { markAllRead } = thread

  // Mark read on the Inbox's dwell, not on mount: the queue auto-advances, and
  // marking on mount would clear unread on rows it merely passed through.
  useEffect(() => {
    const timer = setTimeout(() => {
      markAllRead()
      onRead()
    }, MARK_READ_DELAY_MS)
    return () => clearTimeout(timer)
  }, [contact.id, markAllRead, onRead])

  return (
    // `ConversationPanel` fills its parent, so it needs a definite height.
    <div className="h-96 px-4 py-3">
      <ConversationPanel
        contact={contact}
        messages={thread.messages}
        loading={thread.loading}
        sending={thread.sending}
        failed={thread.failed}
        active
        onSend={thread.send}
        onBack={onClose}
        onRetry={thread.refresh}
      />
    </div>
  )
}
